import React from 'react';
import {
  ClearRounded,
  CheckCircle,
  LibraryBooksRounded,
  TextSnippetRounded,
  ScheduleRounded,
} from '@mui/icons-material';
import { TaskIcon, FormIcon, DocIcon, ProjectIcon, ReoccurringIcon, ReadUnderstoodIcon } from '../Icons';
import { AuditIcon, ProcessIcon, RoutineIcon, AssetIcon } from '../Icons';
import { blue, red, grey } from '@mui/material/colors';

const TaskTypes = {
  reoccurring: { text: 'Reoccuring', icon: <ReoccurringIcon /> },
  task: { text: 'Task', icon: <TaskIcon /> },
  workflow: { text: 'Workflow', icon: <TaskIcon /> },
  formhub: { text: 'Form hub', icon: <FormIcon /> },
  dochub: { text: 'Doc hub', icon: <DocIcon /> },
  hub: { text: 'Doc hub', icon: <DocIcon /> },
  project: { text: 'Project', icon: <ProjectIcon /> },
  review_action: { text: 'Review Action', icon: <FormIcon /> },
  ncr: { text: 'Audit NCR', icon: <AuditIcon /> },
  audit: { text: 'Audit', icon: <AuditIcon /> },
  doc_approval: { text: 'Document Approval', icon: <DocIcon /> },
  process_approval: { text: 'Process Approval', icon: <ProcessIcon /> },
  process_step: { text: 'Process Step', icon: <ProcessIcon /> },
  process: { text: 'Process Step', icon: <ProcessIcon /> },
  form: { text: 'Form entry', icon: <FormIcon /> },
  scheduled: { text: 'Scheduled', icon: <ScheduleRounded style={{ color: grey[500] }} /> },
  approval: { text: 'Approval', icon: <CheckCircle style={{ color: blue[600] }} /> },
  assetRecalling: { text: 'Asset recalling', icon: <ClearRounded style={{ color: red[500] }} /> },
  assetExpiry: { text: 'Asset expiry', icon: <ClearRounded style={{ color: red[500] }} /> },
  routine: { text: 'Routine', icon: <RoutineIcon /> },
  form_entry: { text: 'Form entry', icon: <FormIcon /> },
  ru: { text: 'Read and understood', icon: <ReadUnderstoodIcon /> },
  review: { text: 'Review', icon: <LibraryBooksRounded style={{ color: grey[500] }} /> },
  asset: { text: 'Asset', icon: <AssetIcon /> },
  auditAction: { text: 'Audit action', icon: <AuditIcon /> },
  dataRequest: { text: 'Data request', icon: <TextSnippetRounded style={{ color: grey[500] }} /> },
};

export default TaskTypes;
